import { LOCALE } from '../../../constants/activity-constants'

const arg = LOCALE === 'es-AR'

export const textCountry = {
  text1: arg
    ? 'Si aún no tenés una cuenta y querés participar'
    : 'Si aún no tienes una cuenta y quieres participar',
  textLink1: 'Quiero registrarme',
}
